<!--Loading Spinner-->
<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>
<!-- Main content -->
<div class="content">
  <div class="container-fluid">
    <div class="row" style="padding-top: 5px;">
      <div class="col-lg-6">
          <div class="card card-success card-outline">
              <div class="card-header d-flex align-items-center flex-wrap">
                <h5 class="m-0">Performance By Sales Reps</h5>
                <div class="ml-auto">
                  <app-date-filter (filterChange)="onRepsFilterChange($event)"></app-date-filter>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8"></div>
                  <div class="col-md-4">
                    <div class="row">
                        <div class="col" style="margin: 2px 5px;">
                            <input type="text" class="form-control" placeholder="Type Sales Rep's name to search..." (input)="salesRepsPerformanceOnSearchTextChange($event)">
                        </div>
                    </div>
                  </div>
                </div>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Branch</th>
                      <th>Sales Target</th>
                      <th>Sale Offers</th>
                      <th>Closed Deals</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let rep of salesRepsPerformance | searchSalesRep: searchsalesRepsPerformanceText | paginate: { itemsPerPage: 5, currentPage: salesRepsPerformancePage, totalItems: salesRepsPerformanceCount, id: 'sales_reps' }">
                      <td>{{ rep.sales_rep_name }}</td>
                      <td>{{ rep.branch }}</td>
                      <td>{{ rep.sales_target }}</td>
                      <td>{{ rep.sale_offers }}</td>
                      <td>{{ rep.closed_deals }}</td>
                    </tr>
                    <tr *ngIf="salesRepsPerformance.length === 0">
                      <td colspan="5" class="text-center">
                        No sales performance records found!
                      </td>
                    </tr>
                  </tbody>
                </table>
                <pagination-controls (pageChange)="salesRepsPerformancePageChangeEvent($event)" id="sales_reps"></pagination-controls>
              </div>
         </div>

        <div class="card card-success card-outline">
          <div class="card-header d-flex align-items-center flex-wrap">
            <h5 class="m-0">Recent Sale Offers</h5>
            <div class="btn-group btn-group-sm ml-auto" role="group" aria-label="Offers by customer category filter">
             <!---Filter buttons here-->
            </div>
          </div>
          <div class="card-body table-responsive p-0" style="overflow-x: auto; overflow-y: auto; white-space: nowrap;">
            <div class="row">
                  <div class="col-md-8"></div>
                  <div class="col-md-4">
                    <div class="row">
                        <div class="col" style="margin: 2px 5px;">
                            <input type="text" class="form-control" placeholder="Type here to search..." (input)="recentOffersOnSearchTextChange($event)">
                        </div>
                    </div>
                  </div>
            </div>
            <table class="table table-striped table-hover mb-0">
              <thead>
                <tr>
                  <th>Make/Model</th>
                  <th>Chassis No.</th>
                  <th>Customer Name</th>
                  <th>Customer Phone No.</th>
                  <th>Customer Type</th>
                  <th>Deal Type</th>
                  <th>Sales Rep Name</th>
                  <th>Vehicle's Location</th>
                  <th>Posted On</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let offer of recentSaleOffers | searchRecentOffers: searchRecentOffersText | paginate: { itemsPerPage: 5, currentPage: recentOffersPage, totalItems: recentOffersCount, id: 'offers' }">
                  <td>{{ offer.make_name }} {{ offer.model_name }}</td>
                  <td>{{ offer.chassis_no }}</td>
                  <td>{{ offer.customer_name }}</td>
                  <td>{{ offer.customer_phone_no }}</td>
                  <td>{{ offer.customer_type }}</td>
                  <td>
                    <span class="badge" [ngClass]="offer.deal_type === 'Cash' ? 'badge-success' : 'badge-primary'">
                      {{ offer.deal_type }}
                    </span>
                  </td>
                  <td>{{ offer.sales_rep_name }}</td>
                  <td>{{ offer.location_name }}-{{ offer.branch_name }}</td>
                  <td>{{ offer.posted_on | timeAgo }}</td>
                  <td class="text-right">
                   <a
                    class="btn btn-sm btn-outline-secondary"
                    [routerLink]="['/view-vehicle-details', offer.vehicle_id]"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i class="fas fa-eye"></i> View
                  </a>
                  </td>
                </tr>
                <tr *ngIf="recentSaleOffers.length === 0">
                  <td colspan="10" class="text-center">
                    No recent sale offers available!
                  </td>
                </tr>
              </tbody>
            </table>
            <pagination-controls (pageChange)="recentOffersPageChangeEvent($event)" id="offers"></pagination-controls>
          </div>
        </div><!-- /.card -->
      </div>
      <!-- /.col-md-6 -->
      <div class="col-lg-6">
        <div class="card card-success card-outline">
          <div class="card-header d-flex align-items-center flex-wrap">
            <h5 class="m-0">Sale Offers By Customer Category & Type</h5>
            <div class="ml-auto">
              <app-date-filter (filterChange)="onCategoryTypeFilterChange($event)"></app-date-filter>
            </div>
          </div>
          <div class="card-body" style="width: 600px;height:400px;">
            <div class="row">
              <div class="col-md-6">
                <canvas #categoryPieCanvas></canvas>
              </div>
              <div class="col-md-6">
                <canvas #typeDonutCanvas></canvas>
              </div>
            </div>
          </div>
        </div>

        <div class="card card-success card-outline">
          <div class="card-header d-flex align-items-center flex-wrap">
            <h5 class="m-0">Sales Performance By Branch</h5>
            <div class="ml-auto">
              <app-date-filter (filterChange)="onBranchFilterChange($event)"></app-date-filter>
            </div>
          </div>
          <div class="card-body" style="width: 600px;height:400px;">
            <canvas #branchBarCanvas></canvas>
          </div>
        </div>
      </div>
      <!-- /.col-md-6 -->
    </div>
    <!-- /.row -->
  </div><!-- /.container-fluid -->
</div>
<!-- /.content -->
